import { render } from "./changepasswordmodals.vue?vue&type=template&id=00466df3"
import script from "./changepasswordmodals.vue?vue&type=script&lang=js"
export * from "./changepasswordmodals.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__